import { useEffect, useState } from 'react';
import { CircularProgress, Typography, Card, CardContent, Button, makeStyles } from '@material-ui/core';
import { Switch, Route, Link, useRouteMatch } from 'react-router-dom';
import { getProfile, isLoggedIn } from '../../data';
import ScheduleManager from './schedule-manager';
import PlayersManager from './players-manager';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        minHeight: 400,
        width: '100%',
        padding: theme.spacing(2),
    },
    content: {
        maxWidth: 1200,
        flex: 'auto',
        padding: theme.spacing(4),
    },
    heading: {
        marginBottom: theme.spacing(3),
    },
    nav: {
        display: 'flex',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
    },
}));

export default function SuperAdmin() {
    const classes = useStyles();
    const { path, url } = useRouteMatch();
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        (async () => {
            const loggedIn = await isLoggedIn();
            if (loggedIn) {
                const profile = await getProfile();
                setAuthorized(profile.superAdmin === true);
            }
            setLoading(false);
        })();
    }, []);

    if (loading) {
        return (
            <div className={classes.root}>
                <CircularProgress />
            </div>
        );
    }

    if (!authorized) {
        return (
            <div className={classes.root}>
                <Card>
                    <CardContent className={classes.content}>
                        <Typography variant="h6">Access Denied</Typography>
                        <Typography>You do not have permission to view this page.</Typography>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Typography variant="h5" className={classes.heading}>Super Admin</Typography>
                <div className={classes.nav}>
                    <Link to={`${url}`}>
                        <Button variant="outlined" size="small">Dashboard</Button>
                    </Link>
                    <Link to={`${url}/schedule`}>
                        <Button variant="outlined" size="small">Schedule</Button>
                    </Link>
                    <Link to={`${url}/players`}>
                        <Button variant="outlined" size="small">Players</Button>
                    </Link>
                </div>
                <Switch>
                    <Route exact path={path}>
                        <Card>
                            <CardContent>
                                <Typography>Select a feature above to manage.</Typography>
                            </CardContent>
                        </Card>
                    </Route>
                    <Route path={`${path}/schedule`}>
                        <ScheduleManager />
                    </Route>
                    <Route path={`${path}/players`}>
                        <PlayersManager />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
